import React from "react";

export interface AudioPlayerContextValue {
  play: (
    playerId: string,
    src: string,
    mime: string,
    currentTime: number,
    options: { resetPlayer: boolean }
  ) => void;
  pause: (playerId: string) => void;
  setCurrentTime: (playerId: string, currentTime: number) => void;
}

export const AudioPlayerContext = React.createContext<AudioPlayerContextValue>(
  null as any
);
